import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { ProfileViewEnum } from '@qaroni-app/account/types/profile-view.enum';
import { ImagesConfig } from '@qaroni-core/conf/images/images.config';
import { AccountAvatarComponent } from '../account-avatar/account-avatar.component';
import { Account } from '@qaroni-app/account/types/account';

@Component({
  selector: 'qaroni-account-info',
  standalone: true,
  imports: [AccountAvatarComponent],
  templateUrl: './account-info.component.html',
  styleUrl: './account-info.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccountInfoComponent implements OnChanges {
  @Input() account: Account | null = null;
  @Output() changeView = new EventEmitter<ProfileViewEnum>();

  public ProfileViewEnum = ProfileViewEnum;
  public ImagesConfig = ImagesConfig;

  ngOnChanges(changes: SimpleChanges): void {
    const account = changes['account'].currentValue as Account | null;

    if (!account) {
      return;
    }

    this.account = account;
  }

  public changeViewEdit(view: ProfileViewEnum): void {
    this.changeView.emit(view);
  }
}
